/**
 * Точка входа фичи "Спецификация проекта".
 *
 * Инициализируется автоматически только на страницах спецификации (маркер:
 * <input name="project_id">). Модули:
 *  - store.js   — общий state + cookies
 *  - filters.js — выпадающие фильтры
 *  - actions.js — кнопки расчёт/заказ/экспорт-триггеры, updateActionButtons
 *  - table.js   — таблица: обработчики, загрузка, DnD, количество, комментарии, свёртка
 *  - modals.js  — delete-confirm (add-product через window.ProductSelectionModal)
 *  - columns.js — видимость и порядок колонок
 *  - export.js  — Excel/PDF экспорт
 */

import { state } from './store.js';
import { initFilterHandlers } from './filters.js';
import { initActionButtons } from './actions.js';
import { initTableHandlers } from './table.js';
import { initModalHandlers, openDeleteProductModal, closeDeleteProductModal } from './modals.js';
import { initColumnVisibility } from './columns.js';
import { initSpecChat, applyUnreadCounts } from '../spec-chat/index.js';
import { apiRequest } from '../../api.js';

function init() {
    const projectInput = document.querySelector('input[name="project_id"]');
    // DEV-1034/DEV-1035: в read-only режиме (менеджер не владелец) скрытого
    // input[name="project_id"] нет — берём id из window.specProjectId.
    const readOnly = window.specReadOnly === true;
    const projectId = projectInput ? projectInput.value : (window.specProjectId || null);
    if (!projectId) return; // не страница спецификации

    state.projectId = String(projectId);

    if (readOnly) {
        // Только безопасное подмножество: выбор строк (select-all + чекбоксы)
        // и экспорт (Excel/PDF). Без Sortable/reorder, add-product, мутаций статуса.
        initActionButtons();
        initSpecChat(state.projectId);
        refreshUnreadCounts();
        setInterval(refreshUnreadCounts, 30000);
        document.addEventListener('visibilitychange', () => {
            if (!document.hidden) refreshUnreadCounts();
        });
        return;
    }

    initFilterHandlers();
    initTableHandlers();
    initModalHandlers();
    initColumnVisibility();
    initActionButtons();
    initSpecChat(state.projectId);

    // DEV-329: первоначальный и периодический рендер badge’ей непрочитанных.
    refreshUnreadCounts();
    setInterval(refreshUnreadCounts, 30000);
    document.addEventListener('visibilitychange', () => {
        if (!document.hidden) refreshUnreadCounts();
    });
}

async function refreshUnreadCounts() {
    if (!state.projectId) return;
    try {
        const data = await apiRequest(`/project/${state.projectId}/spec-chat/unread-counts`);
        if (data?.success) applyUnreadCounts(data.counts || {}, data.has_messages || []);
    } catch (e) {
        // молча — polling
    }
}

// Публичный API для inline-скриптов в Blade
window.openDeleteProductModal = openDeleteProductModal;
window.closeDeleteProductModal = closeDeleteProductModal;

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
